/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripPaymentsAccessorialsTable: "trip-payments-accessorials-table",
  tripPaymentsComputeLineHaulPay: "trip-payments-compute-line-haul-pay",
} as const;
